import { WarningIcon } from '@farol-ds/react'

import styles from './error-message.module.scss'

interface ErrorMessageProps {
  message: string
}

export function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className={styles.errorMessage} role="alert">
      <WarningIcon className={styles.errorMessageIcon} />
      <span className={styles.errorMessageText}>{message}</span>
    </div>
  )
}
